import type { TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";

export type AirportBusResolvedApiPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      infoPath: string;
      bookingsPath: string;
      /** Hotel estimation POST path (v2). */
      estimationV2Path: string;
      /** Airline estimation POST path builder. */
      estimationAirlinePath: (iataCode: string) => string;
    };

function airlineTransportsBasePath(typeSegment: string, iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/transports/${typeSegment}`;
}

function airlineBookingsPath(iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/bookings`;
}

/**
 * Resolves Airport Bus API paths for hotel and airline contexts.
 * `typeSegment` is the GetLocal transport-type slug (e.g. vienna-airport-bus), not a carrier code.
 */
export function resolveAirportBusApiPaths(
  typeSegment: string,
  transportContext: TransportAirlineApiContext
): AirportBusResolvedApiPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }

  if (transportContext.mode === "airline") {
    return {
      kind: "ok",
      infoPath: airlineTransportsBasePath(typeSegment, transportContext.iataCode),
      bookingsPath: airlineBookingsPath(transportContext.iataCode),
      estimationV2Path: `v2/transport/${typeSegment}`,
      estimationAirlinePath: iataCode => airlineTransportsBasePath(typeSegment, iataCode)
    };
  }

  return {
    kind: "ok",
    infoPath: `transport/${typeSegment}`,
    bookingsPath: "bookings",
    estimationV2Path: `v2/transport/${typeSegment}`,
    estimationAirlinePath: iataCode => airlineTransportsBasePath(typeSegment, iataCode)
  };
}
